export default "__VITE_ASSET__Cb72kZA7__"